<template>
    <div>
        <my-sub-title class="mg-top10">累计概览（截止到{{info.upd_time}}）</my-sub-title>
        <div class="flex-box nopadding wrap pd-top10">
            <div class="round-10 card-box bg1 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <div class="flex-box-bd tleft">
                        <div class="f-red">
                            <span class="f18 mg-right3 f-bd num">{{info.end_order_qty || 0}}</span>笔
                            <span class="mg-left3 mg-right3">/</span>
                            <span class="f18 mg-right3 f-bd num">{{(info.end_goods_amt || 0) * 1}}</span>元
                        </div>
                        <div class="f14">成功笔数 / 面值</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg1 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="ios-calculator" />
                    <div class="flex-box-bd tleft">
                        <div class="num f-red"><span class="f18 mg-right3 f-bd">{{ (info.end_guest_cost_amt || 0) * 1}}</span>元</div>
                        <div class="f14">成功结算价</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg1 width-250 pd-10 mg-right10 mg-bottom10" v-if="info.bal_cr_qty">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="md-checkmark-circle-outline" />
                    <div class="flex-box-bd tleft">
                        <div class="num f-red"><span class="f18 mg-right3 f-bd">{{ info.bal_cr_qty * 1}}</span></div>
                        <div class="f14">信誉余额(实时)</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg1 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="md-funnel" />
                    <div class="flex-box-bd tleft">
                        <div class="num"><span class="f18 mg-right3 f-bd">{{ (info.end_cr_cat10_qty || 0)}}</span>单</div>
                        <div class="f14">信誉按单量消耗</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg1 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="logo-yen" />
                    <div class="flex-box-bd tleft">
                        <div class="num"><span class="f18 mg-right3 f-bd">{{ (info.end_cr_cat20_qty * 1 || 0)}}</span>元</div>
                        <div class="f14">信誉按面额消耗</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg1 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="md-options" />
                    <div class="flex-box-bd tleft">
                        <div class="num"><span class="f18 mg-right3 f-bd">{{ (info.end_api_use_qty || 0)}}</span>次</div>
                        <div class="f14">API 调用量</div>
                    </div>
                </div>
            </div>
        </div>
        <my-sub-title class="mg-top20">今日概览（截止到{{info.upd_time}}）</my-sub-title>
        <div class="flex-box nopadding wrap pd-top10">
            <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <div class="flex-box-bd tleft">
                        <div class="f-red">
                            <span class="f18 mg-right3 f-bd num">{{info.mv_order_qty || 0}}</span>笔
                            <span class="mg-left3 mg-right3">/</span>
                            <span class="f18 mg-right3 f-bd num">{{(info.mv_goods_amt || 0) * 1}}</span>元
                        </div>
                        <div class="f14">成功笔数 / 面值</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="ios-calculator" />
                    <div class="flex-box-bd tleft">
                        <div class="num f-red"><span class="f18 mg-right3 f-bd">{{ (info.mv_guest_cost_amt || 0) * 1}}</span>元</div>
                        <div class="f14">成功结算价</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="md-funnel" />
                    <div class="flex-box-bd tleft">
                        <div class="num"><span class="f18 mg-right3 f-bd">{{ (info.mv_cr_cat10_qty || 0)}}</span>单</div>
                        <div class="f14">信誉按单量消耗</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="logo-yen" />
                    <div class="flex-box-bd tleft">
                        <div class="num"><span class="f18 mg-right3 f-bd">{{ (info.mv_cr_cat20_qty * 1 || 0)}}</span>元</div>
                        <div class="f14">信誉按面额消耗</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <Icon class="icon-tag" type="md-options" />
                    <div class="flex-box-bd tleft">
                        <div class="num"><span class="f18 mg-right3 f-bd">{{ (info.mv_api_use_qty || 0)}}</span>次</div>
                        <div class="f14">API 调用量</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <div class="flex-box-bd tleft">
                        <div class="f-red">
                            <span class="f18 mg-right3 f-bd num">{{info.fail_order_qty || 0}}</span>笔
                            <span class="mg-left3 mg-right3">/</span>
                            <span class="f18 mg-right3 f-bd num">{{(info.fail_goods_amt || 0) * 1}}</span>元
                        </div>
                        <div class="f14">失败笔数 / 面值</div>
                    </div>
                </div>
            </div>
            <div class="round-10 card-box bg2 width-250 pd-10 mg-right10 mg-bottom10">
                <div class="flex-box nopadding mg-top10">
                    <div class="flex-box-bd tleft">
                        <div class="f-red">
                            <span class="f18 mg-right3 f-bd num">{{info.wait_order_qty || 0}}</span>笔
                            <span class="mg-left3 mg-right3">/</span>
                            <span class="f18 mg-right3 f-bd num">{{(info.wait_goods_amt || 0) * 1}}</span>元
                        </div>
                        <div class="f14">充值中笔数 / 面值</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-box nopadding mg-top20">
            <div class="flex-box-bd pd-10 bg-box" style="min-width: 500px">
                <my-sub-title>分品类</my-sub-title>
                <div class="mg-10 round-5 over-hide">
                    <myEcharsPie id='pie_day_goods' :rows="day_goods.rows" :name_key="day_goods.name_key" :value_key="day_goods.value_key" unit="单"></myEcharsPie>
                </div>
            </div>
            <div class="mg-right10"></div>
            <div class="flex-box-bd pd-10 bg-box" style="min-width: 500px">
                <my-sub-title>API使用分类</my-sub-title>
                <div class="mg-10 round-5 over-hide">
                    <myEcharsPie id='pie_day_api' :rows="day_api.rows" :color="[]" :name_key="day_api.name_key" :value_key="day_api.value_key" unit="次"></myEcharsPie>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myEcharsPie from './myEcharsPie'
    export default {
        name: "mySpViewData",
        components:{
            myEcharsPie
        },
        props:{
            info: {
                default: {},
                type: Object,
            },
            day_api: {
                default: {},
                type: Object,
            },
            day_goods: {
                default: {},
                type: Object,
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mySpViewData.vue